import React from 'react';

interface BrokerBusinessCardProps {
  name: string;
  phone?: string;
  email?: string;
  compact?: boolean;
}

export const BrokerBusinessCard: React.FC<BrokerBusinessCardProps> = ({ name, phone, email, compact = false }) => {
  if (!name) return null;

  const digits = phone ? phone.replace(/\D/g, '') : '';
  const clean10 = digits.length >= 10 ? digits.slice(-10) : digits;
  const formattedPhone = clean10.length === 10
    ? `+57 ${clean10.slice(0, 3)} ${clean10.slice(3, 6)} ${clean10.slice(6)}`
    : (phone || '');

  const waMessage = `Hola ${name}, estuve viendo las propiedades que compartiste y me gustaría recibir más información.`;
  const waUrl = clean10 ? `https://wa.me/57${clean10}?text=${encodeURIComponent(waMessage)}` : '#';

  if (compact) {
    return (
      <div className="bg-gradient-to-r from-sky-900 via-sky-800 to-indigo-900 text-white rounded-2xl p-4 shadow-lg border border-sky-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="flex items-center gap-3 w-full sm:w-auto">
          <div className="w-10 h-10 rounded-full bg-white/10 backdrop-blur-md text-white font-extrabold flex items-center justify-center text-base border border-white/20 flex-shrink-0">
            {name.charAt(0).toUpperCase()}
          </div>
          <div className="min-w-0">
            <span className="text-[10px] uppercase font-black tracking-wider text-sky-200 block">Tu Asesor Inmobiliario</span>
            <h4 className="text-sm font-extrabold truncate text-white">{name}</h4>
            {formattedPhone && <p className="text-xs text-sky-100 font-mono">{formattedPhone}</p>}
          </div>
        </div>
        {clean10 && (
          <div className="flex items-center gap-2 w-full sm:w-auto">
            <a
              href={`tel:+57${clean10}`}
              className="flex-1 sm:flex-none px-3 py-2 bg-white/10 hover:bg-white/20 text-white rounded-xl text-xs font-black uppercase tracking-wider transition-all flex items-center justify-center gap-1 border border-white/20"
            >
              📞 llamar
            </a>
            <a
              href={waUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 sm:flex-none px-3.5 py-2 bg-emerald-500 hover:bg-emerald-600 text-white rounded-xl text-xs font-black uppercase tracking-wider transition-all flex items-center justify-center gap-1 shadow-md"
            >
              💬 WhatsApp
            </a>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-br from-slate-900 via-sky-950 to-indigo-950 text-white rounded-3xl p-6 sm:p-8 shadow-2xl border border-sky-800/40 relative overflow-hidden my-6">
      <div className="absolute top-0 right-0 w-32 h-32 bg-sky-500/10 rounded-full blur-2xl pointer-events-none" />
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 relative z-10">
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 rounded-2xl bg-gradient-to-tr from-sky-500 to-indigo-500 text-white font-black text-xl flex items-center justify-center shadow-lg border-2 border-white/20 flex-shrink-0">
            {name.charAt(0).toUpperCase()}
          </div>
          <div>
            <span className="text-[11px] font-black uppercase tracking-widest text-sky-300 block mb-0.5">Tarjeta de Presentación</span>
            <h3 className="text-lg sm:text-xl font-extrabold text-white tracking-tight">{name}</h3>
            <p className="text-xs text-sky-200 font-medium">Asesor Comercial Certificado</p>
          </div>
        </div>

        {clean10 ? (
          <div className="flex flex-wrap items-center gap-3">
            <a
              href={`tel:+57${clean10}`}
              className="flex-1 sm:flex-none px-4 py-3 bg-white/10 hover:bg-white/20 text-white rounded-2xl text-xs font-extrabold uppercase tracking-wider transition-all flex items-center justify-center gap-2 border border-white/20"
            >
              <span>📞</span> {formattedPhone}
            </a>
            <a
              href={waUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 sm:flex-none px-5 py-3 bg-emerald-500 hover:bg-emerald-600 text-white rounded-2xl text-xs font-extrabold uppercase tracking-wider transition-all flex items-center justify-center gap-2 shadow-lg active:scale-95"
            >
              <span>💬</span> Contactar por WhatsApp
            </a>
          </div>
        ) : (
          email && <p className="text-xs text-sky-200 font-mono">{email}</p>
        )}
      </div>
    </div>
  );
};
